module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"back":"Tilbake"},"en":{"back":"Back"}}')
  delete Component.options._Ctor
}
